import OlVectorTileLayer from 'ol/layer/VectorTile.js';
import OGCVectorTileSource from 'ol/source/OGCVectorTile.js';
import OlMVT from 'ol/format/MVT.js';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Circle from 'ol/style/Circle';
import { applyStyle } from 'ol-mapbox-style';

import { NEDGLOBE_MAP_PROJECTION } from '../../../../constants';
export const createOgctLayer = async function (store, layerData) {

    let result = await store.dispatch('useApiData', {
        name: 'GetTileUrl',
        data: { url: layerData.source.uri_OGC }
    });

    const tileUrl = result.data;

    // if the layer contains a style id try to get the URL for that style.
    const styleUrl = await getStyleUrl(store, layerData.source.uri_OGC, layerData.styles[0].name);

    const vectorTileSource = new OGCVectorTileSource({
        format: new OlMVT(),
        url: tileUrl,
        projection: NEDGLOBE_MAP_PROJECTION,
        cacheSize: 0,
        declutter: true
    });


    // Create the VectorTile layer without the manual style function
    const vectorTileLayer = new OlVectorTileLayer({
        source: vectorTileSource,
        useInterimTilesOnError: false,
    });


    // We have found a style apply this.
    if (styleUrl) {
        applyStyle(vectorTileLayer, styleUrl, { updateSource: false }).then(() => {
        }).catch(error => {
            console.error('Error applying style:', error);
        });
    } else {
        // No style found.
        // Apply a default style.
        vectorTileLayer.setStyle(function (feature) {
            const geometryType = feature.getGeometry().getType();
            switch (geometryType) {
                case 'Point':
                    return new Style({
                        image: new Circle({
                            radius: 5,
                            fill: new Fill({ color: '#000000' }),
                        }),
                    });
                case 'LineString':
                    return new Style({
                        stroke: new Stroke({
                            color: '#000000',
                            width: 2,
                        }),
                    });
                case 'Polygon':
                    return new Style({
                        fill: new Fill({ color: 'rgba(0, 0, 0, 0)' }),
                        stroke: new Stroke({
                            color: '#000000',
                            width: 1,
                        }),
                    });
                default:
                    return null; // No style for unsupported types
            }
        });
    }


    return vectorTileLayer;
};




// Gets a Style Url for the service by Id
// If no Id given try to get a default style
export const getStyleUrl = async function (store, url, styleId) {
    let styleUrl = null;
    let result;

    // Get all styles
    if (styleId) {
        result = await store.dispatch('useApiData', {
            name: 'GetStyleOptions',
            data: { url: url }
        });
        const styles = result.data;

        // Select the style that has the given Id
        styleUrl = styles.find(s => s.id === styleId)?.link || null;

    }

    // No style found, get hte default style
    if (!styleUrl) {
        result = await store.dispatch('useApiData', {
            name: 'GetDefaultStyle',
            data: { url: url }
        });
        styleUrl = result.data;
    }

    return styleUrl;
};

export const getOgcStyleOptions = async function (store, url) {
    const result = await store.dispatch('useApiData', {
        name: 'GetStyleOptions',
        data: { url: url }
    });

    // Remove  (NetherlandsRDNewQuad) from PDOK titles
    return result.data.map((item) => {
        return {
            value: item.id,
            text: item.title.replace(' (NetherlandsRDNewQuad)', '')
        };
    });
};

// Gets the style Json. Given the source URL and the styleId
export const getOgcStyleJson = async function (store, url, styleId) {
    const styleUrl = await getStyleUrl(store, url, styleId);
    try {
        const response = await fetch(styleUrl); // Await the fetch call to complete
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`); // Handle errors
        }
        const data = await response.json(); // Await the conversion to JSON
        return data; // Return the JSON data
    } catch (error) {
        console.error('Fetch error:', error);
        return null; // Or handle error as needed
    }
};
